import React from 'react';




const Mensaje = () => (
    <p>Agrega una cantidad y plazo a pagar para cotizar</p>
);
    
 
export default Mensaje;